'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory('highchartConfigBlocks', function () {
  return {
    legendOnRight: {
      enabled: true,
      align: 'right',
      layout: 'vertical',
      verticalAlign: 'top',
      y: 30,
      backgroundColor: 'rgba(109,176,194,0.1)',
      borderWidth: 0,
      borderRadius: 0
    },
    legendOnBottom: {
      enabled: true,
      align: 'center',
      layout: 'horizontal',
      verticalAlign: 'bottom',
      y: 0,
      backgroundColor: null,
      borderWidth: 0,
      borderRadius: 0,
      // on retire tout caractère flottant (parfois utilisé quand legende à droite)
      floating: false
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/highcharts/highcharts-config-blocks.js
// module id = 2962
// module chunks = 13